import { Button, Container, Switch, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useMediaQuery } from "@mui/material";
import styles from "../Accounts.module.scss";
import AuthContext from "../../../hooks/authContext";
import {
  getIndustriesList,
  getIndustryServices,
} from "../../../services/apiservices/supplies";
import {
  datetimest,
  generateFirebaseId,
} from "../../../services/helpers";
import {
  getServicesDetails,
  getSettings,
  resetSettings,
  resetSuppliesIndustry,
  saveOrUpdateSuppliesIndustry,
  saveSettings,
  saveSuppliesIndustry,
  updateSettings,
} from "../../../services/apiservices/settings";
import {
  CommonConfirmationDialog,
  CommonSuccessDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import { Building } from "lucide-react";
import { useNavigate } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import CommonContext from "../../../hooks/commonContext";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import ClientSettingDetails from "./ClientIndustryDetails";
import { getAllEmployee, getCompanyUsers, setAnyUserData } from "../../../services/apiservices/employee";
import SingleSelectSearch from "../../../components/SelectField/SelectSearch";
import { useToast } from "../../../hooks/useToast";
import ChangeHistory from "./History";
import moment from "moment-timezone";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Input } from "../../../components/ui/input";
import { updateStripeCustomerName } from "../../../services/apiservices/users";

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

const CompanyPageSetting = () => {
  const commonContext = useContext(CommonContext);
  const auth = useContext(AuthContext);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [enableReporting, setEnableReporting] = useState(false);
  const [serviceTypes, setServiceTypes] = useState();
  const [servicesTasks, setServicesTasks] = useState();
  const [editingTask, setEditingTask] = useState(null);
  const [editingBusiness, setEditingBusiness] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [companyEdit, setCompanyEdit] = useState(false);
  const [newTask, setNewTask] = useState({ taskName: "", description: "" });
  const [newIndustry, setNewIndustry] = useState({ name: "", description: "" });
  const [newServiceType, setNewServiceType] = useState({
    name: "",
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [stepError, setStepError] = useState({});
  const [companyLogo, setCompanyLogo] = useState(null);
  const [industryName, setIndustryName] = useState();
  const [industry, setIndustry] = useState();
  const [industryNameList, setIndustryNameList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [categoryIds, setCategoryIds] = useState([]);
  const [subCategoryIds, setSubCategoryIds] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [filterData, setFilterData] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);
  const [resetSuccessOpen, setResetSuccessOpen] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [confirmationFinalDialog, setFinalConfirmationDialog] = useState(false);
  const [temparyIndustryName, setTempraryIndustryName] = useState(null);
  const [employeeData, setEmployeeData] = useState(null);
  const [tab, setTab] = useState("industry");
  const navigate = useNavigate();
  const { toast } = useToast();
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

      
  const companyUser = Array.isArray(auth?.userProfile?.role) ? auth?.userProfile.role.includes("companyUser") : auth?.userProfile?.role === "companyUser";

  const fetchIndustries = async () => {
    if (filterData?.length) return;
    try {
      commonContext?.setLoader(true);
      const industriesRes = await new Promise((resolve, reject) =>
        getIndustriesList({}, (res) =>
          res ? resolve(res) : reject("Failed to fetch industries")
        )
      );

      const sortedIndustries = sortingFunction(industriesRes);
      setIndustry(sortedIndustries);
      setCategoryIds(sortedIndustries?.map((item) => item.id));
      setIndustryNameList([
        { value: "Add Industry", label: "Add Industry" },
        ...sortedIndustries.map((item) => ({
          value: item.id,
          label: item.title,
        })),
      ]);
      await getIndustryServices({}, (res) => {
        if (res) {
          const allCategoryIds = res?.map((item) => item?.id);
          setSubCategoryIds(allCategoryIds);

          const matchedCategories = res.filter((item) =>
            sortedIndustries?.some((ind) => ind?.id === item?.parentCategoryId)
          );
          setCategories(matchedCategories);

          const findSubCategories = (parentIds) => {
            let foundSubCategories = res?.filter((item) =>
              parentIds?.includes(item?.parentCategoryId)
            );
            return foundSubCategories?.length > 0
              ? [
                  ...foundSubCategories,
                  ...findSubCategories(
                    foundSubCategories?.map((item) => item?.id)
                  ),
                ]
              : foundSubCategories;
          };

          setSubCategories(
            sortingFunction(
              findSubCategories(matchedCategories?.map((item) => item?.id))
            )
          );
        }
      });
    } catch (error) {
      console.error(error);
      setIndustryNameList([]);
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const fetchServicesDetails = async (filteredData) => {
    if (!filteredData?.length || !filteredData[0]?.industry?.id) return;

    getServicesDetails(companyId, (res) => {
      if (!res?.data) return;

      const industryId = filteredData[0].industry.id;
      const serviceTypes = res.data.filter(
        (item) => item.parentCategoryId === industryId && !item.deleted
      );
      const servicesTasks = res.data.filter(
        (item) => item.parentCategoryId !== industryId && !item.deleted
      );

      setServiceTypes(sortingFunction(serviceTypes));
      setServicesTasks(sortingFunction(servicesTasks));
    });
  };

    const fetchInitialData = async () => {
      try {
        commonContext?.setLoader(true);

        const [employeeRes, settingsRes] = await Promise.all([
          new Promise((resolve) => getCompanyUsers(companyId, (res) => resolve(res?.data || []))),
          new Promise((resolve) =>
            getSettings("client_settings", (res) => resolve(res?.data))
          ),
        ]);

        const companyNames = employeeRes?.find((item)=> item.id === companyId);
        setCompanyName(companyNames?.companyName || "");

        setEmployeeData(employeeRes);
        const filteredData = settingsRes.filter(
          (item) => item.companyId === companyId && !item.deleted
        );
        setFilterData(filteredData?.length ? filteredData : []);

        if (filteredData?.length > 0) {
          const selectedIndustry = filteredData[0]?.industry?.id || null;
          setIndustry([filteredData[0]?.industry]);
          setStartDate(filteredData[0]?.startDate ? moment(filteredData[0]?.startDate, "YYYY-MM-DD") : null);
          setEndDate(filteredData[0]?.endDate ? moment(filteredData[0]?.endDate, "YYYY-MM-DD") : null);
          setIndustryName(selectedIndustry);
          setCompanyLogo(filterData?.[0]?.companyLogo)
          setEnableReporting(filteredData[0]?.enableReporting || false);
          await fetchServicesDetails(filteredData);
          await fetchIndustries();
        } else {
          await fetchIndustries();
          setEnableReporting(false);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
        setFilterData([]);
        setIndustry(null);
        setStartDate();
        setCompanyLogo(null);
        setEndDate();
        setEnableReporting(false);
      } finally {
        commonContext?.setLoader(false);
      }
    };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const sortingFunction = (data) => {
    const result = data?.sort((a, b) => {
      const titleA = a?.title?.toLowerCase() || "";
      const titleB = b?.title?.toLowerCase() || "";
      return titleA?.localeCompare(titleB);
    });

    return result;
  };

  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;

    setCompanyName(value)

  }
  // Get tasks for selected business
  const getBusinessTasks = (id) => {
    return servicesTasks?.filter(
      (task) => task.parentCategoryId === id && !task.deleted
    );
  };

  // Add new industry
  const handleAddIndustry = () => {
    const newItemId = generateFirebaseId(categoryIds);
    if (newIndustry.name) {
      const business = {
        id: newItemId,
        title: newIndustry.name,
        orders: industry.length + 1,
        status: true,
      };
      setIndustry([...industry, business]);
      const data = [...industry, business];
      const details = data?.map((item) => ({
        value: item.id,
        label: item.title,
      }));
      setIndustryNameList(details);
      setNewIndustry({ name: "", description: "" });
    }
  };

  const handleAddServiceType = () => {
    if (!industryName) {
      setDialogOpen(false);
      setErrors({ industry: true });
      return;
    }

    const newItemId = generateFirebaseId(subCategoryIds);
    const { name, description } = newServiceType;

    if (!name || !description) {
      setErrors({
        serviceTypeName: !name,
        serviceTypeDescription: !description,
      });
      return;
    }

    const business = {
      id: newItemId,
      title: name,
      orders: serviceTypes.length + 1,
      status: true,
      description,
      parentCategoryId: industryName,
      isUpdated: true,
    };

    setServiceTypes(recalculateOrders([...serviceTypes, business]));
    setNewServiceType({ name: "", description: "" });
    setDialogOpen(false);
  };

  // // Edit service type
  const handleSaveServiceTypeEdit = () => {
    if (!industryName) {
      setDialogOpen(false);
      setErrors({ industry: true });
      return;
    }

    const updatedServiceTypes = serviceTypes?.map((business) =>
      business.id === editingBusiness.id
        ? {
            ...business,
            id: business.id,
            title: newServiceType.name,
            orders: business.orders,
            status: true,
            parentCategoryId: industryName,
            isUpdated: true,
          }
        : business
    );

    setServiceTypes(recalculateOrders(updatedServiceTypes));

    setDialogOpen(false);
    setEditingBusiness(null);
    setNewServiceType({ name: "", description: "" });
  };

  // Delete business
  const handleDeleteServiceType = (id) => {
    const updatedServiceTypes = serviceTypes?.map((item) =>
      item.id === id ? { ...item, deleted: true, isUpdated: true } : item
    );

    setServiceTypes(recalculateOrders(updatedServiceTypes));

    const updatedTasks = servicesTasks?.map((task) =>
      task.parentCategoryId === id
        ? { ...task, deleted: true, isUpdated: true }
        : task
    );

    setServicesTasks(recalculateOrders(updatedTasks));
  };

  // Add new task
  const handleAddTask = (businessId) => {
    const taskDetails = servicesTasks?.filter(
      (item) => item.parentCategoryId === businessId && !item.deleted
    );
    const data = sortingFunction(taskDetails);

    const newItemId = generateFirebaseId(subCategoryIds);
    const taskName = newTask[businessId]?.taskName;
    const description = newTask[businessId]?.description;

    if (taskName && description) {
      const task = {
        id: newItemId,
        title: taskName,
        description: description,
        orders: data.length + 1,
        parentCategoryId: businessId,
        status: true,
        isUpdated: true,
      };

      setServicesTasks(recalculateOrders([...servicesTasks, task]));
      setSubCategories(recalculateOrders([...subCategories, task]));

      setNewTask({
        ...newTask,
        [businessId]: { taskName: "", description: "" },
      });

      // Clear errors only for this businessId
      setErrors((prev) => ({
        ...prev,
        [businessId]: { serviceTaskName: false, serviceTaskDes: false },
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [businessId]: {
          serviceTaskName: !taskName,
          serviceTaskDes: !description,
        },
      }));
    }
  };

  // Edit task
  const handleSaveTaskEdit = (businessId) => {
    const updatedSubCategories = servicesTasks?.map((task) =>
      task.id === editingTask.id
        ? {
            ...task,
            id: task.id,
            title: newTask[businessId]?.taskName,
            description: newTask[businessId]?.description,
            orders: task.orders,
            parentCategoryId: businessId,
            status: true,
            isUpdated: true,
          }
        : task
    );

    setServicesTasks(recalculateOrders(updatedSubCategories));

    setEditingTask(null);
    setNewTask({ ...newTask, [businessId]: { taskName: "", description: "" } });
  };

  // Cancel task
  const handleCancelTask = (businessId) => {
    setEditingTask(null);
    setNewTask({ ...newTask, [businessId]: { taskName: "", description: "" } });
  };

  // Delete task
  const handleDeleteTask = (taskId) => {
    const updatedTasks = servicesTasks?.map((task) =>
      task.id === taskId ? { ...task, deleted: true, isUpdated: true } : task
    );

    const parentCategoryId = updatedTasks?.find(
      (task) => task.id === taskId
    )?.parentCategoryId;
    if (!parentCategoryId) return;

    const finalTasks = recalculateOrders(updatedTasks);

    setServicesTasks(finalTasks);
  };

  const recalculateOrders = (categoriesItems) => {
    const activeItems = categoriesItems?.filter((item) => !item.deleted);

    const groupedItems = activeItems.reduce((acc, item) => {
      const { parentCategoryId } = item;
      acc[parentCategoryId] = acc[parentCategoryId] || [];
      acc[parentCategoryId].push(item);
      return acc;
    }, {});

    const updatedItems = Object.values(groupedItems).flatMap((items) =>
      items
        .sort((a, b) => a.orders - b.orders)
        .map((item, index) => ({
          ...item,
          orders: index + 1,
        }))
    );

    const removedItems = categoriesItems.filter((item) => item.deleted);
    return [...updatedItems, ...removedItems];
  };

  const handleCompanyConfirm = async () => {
    setCompanyEdit(false);
    if (filterData?.length === 0) {
      await proceedSaveData();
    } else {
      await proceedUpdateData();
    }
  };


  const handleConfirm = async () => {
    setShowConfirmPopup(false);
    if (filterData?.length === 0) {
      await proceedSaveData();
    } else {
      await proceedUpdateData();
    }
  };

  const handleSaveData = async () => {
    if (!industryName) {
      setErrors({
        industry: !industryName,
      });
      return;
    }

    setErrors({ industry: false });

    if (filterData?.length === 0 && startDate && endDate) {
      setShowConfirmPopup(true);
      return;
    }

    await proceedSaveData();
  };

  const proceedSaveData = async () => {
    try {
      if (!industryName) {
        setErrors({
          industry: !industryName,
        });
        return;
      }

      setErrors({ industry: false });
      commonContext?.setLoader(true);

      const industryDetails = industry?.find(
        (item) => item.id === industryName
      );

      const updatedServiceTypes =
        serviceTypes?.map((item) => {
          const { isUpdated, ...rest } = item;
          return {
            ...rest,
            companyId,
          };
        }) || [];

      const subDetails = servicesTasks?.filter((items) =>
        updatedServiceTypes.some((item) => item.id === items.parentCategoryId)
      );

      const updatedTasks =
        subDetails?.map((item) => {
          const { isUpdated, ...rest } = item;
          return {
            ...rest,
            companyId,
          };
        }) || [];

    const companyNames = employeeData?.find((item)=> item.id === companyId);
    const companyNameChanged = companyUser && companyNames?.companyName?.trim() !== companyName?.trim();

      if ((companyNameChanged) && auth?.userProfile?.customer) {
        await updateStripeCustomerName(auth?.userProfile?.customer, companyName);
        await setAnyUserData(auth?.userProfile?.id, { companyName });
      }

      const dataToSave = {
        companyLogo: companyLogo,
        industry: industryDetails,
        startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
        enableReporting: enableReporting,
        companyId: companyId,
        changes: [
          {
            createdAt: datetimest(),
            industry: industryDetails,
            oldIndustry: "None",
            changedBy: auth?.userProfile?.id,
          },
        ],
      };

      const [settingsData, categoriesData] = await Promise.all([
        saveSettings(dataToSave, "client_settings"),
        updatedTasks.length > 0
          ? saveSuppliesIndustry(updatedTasks, updatedServiceTypes)
          : Promise.resolve({ status: true }),
      ]);

      if (settingsData.status && categoriesData.status) {
        await fetchInitialData();
        toast?.({ title: "Success", description: "Setting Saved Successfully" });
      }
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const handleUpdateData = async () => {
    if (!industryName) {
      setErrors({
        industry: !industryName,
      });
      return;
    }

    setErrors({ industry: false });

    const companyNames = employeeData?.find((item)=> item.id === companyId);
    const companyNameChanged = companyUser && companyNames?.companyName?.trim() !== companyName?.trim();

    if (companyNameChanged) {
      setCompanyEdit(true);
      return;
    }

    const existingStart = filterData?.[0]?.startDate || null;
    const existingEnd = filterData?.[0]?.endDate || null;

    const newStart = startDate ? moment(startDate).format("YYYY-MM-DD") : null;
    const newEnd = endDate ? moment(endDate).format("YYYY-MM-DD") : null;

    if ((existingStart && existingEnd && (existingStart !== newStart || existingEnd !== newEnd)) || ((!existingStart || !existingEnd) && (newStart || newEnd))) {
      setShowConfirmPopup(true);
      return;
    }

    await proceedUpdateData();
  };


  const proceedUpdateData = async () => {
    try {
      if (!industryName) {
        setErrors({
          industry: !industryName,
        });
        return;
      }

      setErrors({ industry: false });
      commonContext?.setLoader(true);

      const industryDetails = industry?.find(
        (item) => item.id === industryName
      );

      const updatedServiceTypes =
        serviceTypes
          ?.filter((item) => item.isUpdated)
          .map((item) =>
            item.companyId === companyId ? item : { ...item, companyId }
          ) || [];

      const subDetails = servicesTasks?.filter((items) =>
        serviceTypes.some((item) => item.id === items.parentCategoryId)
      );

      const updatedTasks =
        subDetails
          ?.filter((item) => item.isUpdated)
          .map((item) =>
            item.companyId === companyId ? item : { ...item, companyId }
          ) || [];
      if (updatedServiceTypes.length === 0 && updatedTasks.length > 0) {
        const requiredServiceTypeIds = [
          ...new Set(updatedTasks.map((task) => task.parentCategoryId)),
        ];
        const additionalServiceTypes = serviceTypes
          ?.filter((item) => requiredServiceTypeIds.includes(item.id))
          .map((item) =>
            item.companyId === companyId ? item : { ...item, companyId }
          );

        updatedServiceTypes.push(...additionalServiceTypes);
      }
      const data = [...updatedServiceTypes, ...updatedTasks];

      const updatedNewTasks = servicesTasks?.map((item) => ({
        ...item,
        companyId: companyId,
      }));

      const updatedNewTypes = serviceTypes?.map((item) => ({
        ...item,
        companyId: companyId,
      }));

      const latestChange = filterData?.[0]?.changes
        ?.filter((item) => item?.createdAt)
        ?.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds)?.[0];
      const oldIndustry = latestChange?.industry ?? "None";

      const newChanges = {
        createdAt: datetimest(),
        changedBy: auth?.userProfile?.id,
        oldIndustry: oldIndustry,
        industry: industryDetails,
      };
      const updatedChanges = [...(filterData?.[0]?.changes || []), newChanges];

      const dataToSave = {
        companyLogo: companyLogo,
        industry: industryDetails,
        enableReporting: enableReporting,
        startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
        companyId: companyId,
        changes: updatedChanges,
      };
      const id = filterData[0]?.id;

      const companyNames = employeeData?.find((item)=> item.id === companyId);
      const companyNameChanged = companyUser && companyNames?.companyName?.trim() !== companyName?.trim();

      if ((companyNameChanged) && auth?.userProfile?.customer) {
        await updateStripeCustomerName(auth?.userProfile?.customer, companyName);
        await setAnyUserData(auth?.userProfile?.id, { companyName });
      }

      const [settingsData, categoriesData] = await Promise.all([
        updateSettings(dataToSave, "client_settings", id),
        (async () => {
          if (data?.length === 0) {
            const resetResult = await resetSuppliesIndustry(companyId);
            if (!resetResult.status) {
              return {
                status: false,
                error: resetResult.error || "Reset failed",
              };
            }
            return await saveOrUpdateSuppliesIndustry(
              updatedNewTasks,
              updatedNewTypes
            );
          } else {
            return await saveOrUpdateSuppliesIndustry(
              updatedTasks,
              updatedServiceTypes
            );
          }
        })(),
      ]);

      if (settingsData.status && categoriesData?.status) {
        await fetchInitialData();
        toast?.({ title: "Success", description: "Setting Update Successfully" });
      }
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const handleResetConfirm = async () => {
    setResetOpen(false);
    commonContext?.setLoader(true);

    const id = filterData[0]?.id;

    try {
      const [details, suppliesData] = await Promise.all([
        resetSettings("client_settings", id),
        resetSuppliesIndustry(companyId),
      ]);

      if (details.status === true && suppliesData.status === true) {
        await fetchInitialData();
        toast?.({ title: "Success", description: "Setting Reset Successfully" });
        commonContext?.setLoader(false);
      }

      commonContext?.setLoader(false);
    } catch (error) {
      console.error("Error resetting settings or supplies:", error);
      commonContext?.setLoader(false);
    }
  };

  const handleIndustryNameChange = (e) => {
    const str = e;
    if (filterData?.length > 0 && str !== "Add Industry") {
      setTempraryIndustryName(str);
      setConfirmationDialog(true);
    } else {
      setIndustryName(str);

      const details = categories?.filter(
        (item) => item?.parentCategoryId === str
      );
      const data = sortingFunction(details);
      setServiceTypes(data);

      const subDetails = subCategories?.filter((items) =>
        data?.some((item) => item?.id === items?.parentCategoryId)
      );
      setServicesTasks(subDetails);
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const maxSizeInBytes = 5 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      setStepError((prevError) => ({
        ...prevError,
        clientLogo: "Logo size must be 5MB or less",
      }));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      setCompanyLogo(base64)
    };
    reader.readAsDataURL(file);
  };


  const onClose = () => {
    setCompanyLogo(null);
  };


  const handleColse = () => {
    setOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Saved Successfully" });
  };

  const handleUpdateClose = () => {
    setUpdateOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Update Successfully" });
  };

  const handleResetClose = () => {
    setResetOpen(false);
  };

  const handleEditDialogClose = () => {
    setCompanyEdit(false);
  };

  const handleResetSuccessClose = () => {
    setResetSuccessOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Reset Successfully" });
  };

  const handleCloseConfirmDialog = () => {
    setConfirmationDialog(false);
  };

  const handleConfirmDialog = () => {
    setConfirmationDialog(false);
    setFinalConfirmationDialog(true);
  };

  const handleFinalCloseConfirmDialog = () => {
    setFinalConfirmationDialog(false);
    setTempraryIndustryName(null);
  };

  const handleFinalConfirmDialog = () => {
    setFinalConfirmationDialog(false);
    setIndustryName(temparyIndustryName);

    const details = categories?.filter(
      (item) => item?.parentCategoryId === temparyIndustryName
    );

    const data = sortingFunction(details);
    setServiceTypes(data);

    const subDetails = subCategories?.filter((items) =>
      data?.some((item) => item?.id === items?.parentCategoryId)
    );

    setServicesTasks(subDetails);
  };

  const handleReset = () => {
    if (filterData?.length > 0) {
      setResetOpen(true);
    } else {
      setFilterData([]);
      setIndustry();
      setIndustryName();
      setEnableReporting(false);
      setServiceTypes();
      setCategories();
      setSubCategories();
      setSubCategoryIds();
      setStartDate();
      setCompanyLogo(null);
      setEndDate();
      setErrors({});
    }
  };

  const handleSwitchChange = () => {
    setEnableReporting(!enableReporting);
  };
  const props = {
    newServiceType,
    setNewServiceType,
    styles,
    errors,
    editingBusiness,
    handleSaveServiceTypeEdit,
    handleAddServiceType,
    serviceTypes,
    setEditingBusiness,
    setDialogOpen,
    handleDeleteServiceType,
    newTask,
    setNewTask,
    handleSaveTaskEdit,
    handleCancelTask,
    handleAddTask,
    getBusinessTasks,
    editingTask,
    setEditingTask,
    handleDeleteTask,
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={`My Company Settings`}
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Settings", to: "/account/settings" },
          ]}
          BreadCrumbCurrentPageTitle={"My Company"}
          showLastSeen={true}
        />
        <div className={isMobile ? "pv-20 ph-15" : "pv-24 ph-32"}>
          <div className="mb-35">
            <div
              className="pv-5 ph-3 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] bg-[#F1F5F9]"
              style={{ width: "240px" }}
            >
              <Button
                onClick={() => setTab("industry")}
                className={`mr-10 ${
                  tab === "industry"
                    ? "bg-white dark:bg-gray-600 dark:text-white"
                    : "dark:bg-[#1A1F2C] dark:text-white"
                }`}
              >
                Industry Settings
              </Button>
              <Button
                className={`ml-10 ${
                  tab === "services"
                    ? "bg-white dark:bg-gray-600 dark:text-white"
                    : "dark:bg-[#1A1F2C] dark:text-white"
                }`}
                onClick={() => setTab("services")}
                // style={{ backgroundColor: tab === "services" ? "white" : "" }}
              >
                Services
              </Button>
            </div>
          </div>{" "}
          {tab === "industry" && (
            <div>
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column w-full"
                    : "d-flex flex-space-between w-full"
                }
              >
                <div  className={"d-flex flex-direction-column w-full"}>
                  <Card className={"w-full bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] mr-20"}>
                    <CardHeader className="pb-12 pt-24 ph-24">
                      <CardTitle className="text-xl ">
                        Automated Reporting
                      </CardTitle>
                      <CardDescription
                        style={{ color: "#64748B", fontSize: "14px" }}
                      >
                        Automatically send client summary reports based on the
                        frequency set when creating a client in the Client
                        module.
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="pt-0 pb-24 ph-24">
                      <div className="flex items-center space-x-2">
                        <AntSwitch
                          checked={enableReporting}
                          onChange={handleSwitchChange}
                          color="primary"
                          name="switchStatus"
                          inputProps={{ "aria-label": "switchStatus" }}
                        />
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                          className="mv-10"
                        >
                          Enable this option to send reports daily, weekly, or
                          monthly. If disabled, reports will not be sent
                          automatically.
                        </p>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className={"w-full bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] mr-20 mt-20"}>
                    <CardHeader className="pb-12 pt-24 ph-24">
                      <CardTitle className="text-xl ">Company Name</CardTitle>
                    </CardHeader>
                    <CardContent className="pt-0 pb-24 ph-24">
                      <div className="flex items-center space-x-2">
                        {companyUser && (
                          <>
                            <div className="formFieldwrap mv-20">
                              <Input
                                size="small"
                                name="companyName"
                                id="companyName"
                                variant="outlined"
                                className="w-100 dark:bg-[#1A1F2C] dark:text-white"
                                disabled={!companyUser}
                                placeholder="Company Name"
                                onChange={handleInputChange}
                                value={companyName ? companyName : ""}
                              />
                            </div>
                          </>
                        )}
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                          className="mv-10"
                        >
                          You can easily update the company name from this section.
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div>

                <Card
                  className={
                    isMobile
                      ? "w-full bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] mt-20"
                      : "w-1/2 bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] ml-20"
                  }
                >
                  <CardHeader className="pb-12 pt-24 ph-24">
                    <CardTitle className="text-xl ">Company Logo</CardTitle>
                    <CardDescription
                      style={{ color: "#64748B", fontSize: "14px" }}
                    >
                      Upload your company logo
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="pt-0 pb-24 ph-24">
                    {companyLogo ? (
                      <div className={styles.logoPreviewWrapper}>
                        <div className={styles.logoPreviewImage}>
                          <img
                            src={companyLogo}
                            alt=""
                            className={styles.imageContain}
                          />
                        </div>
                        <Button
                          variant="outline"
                          size="sm"
                          className={styles.logoResetButton}
                          onClick={onClose}
                        >
                          <CameraAltOutlinedIcon
                            className={styles.iconLarger}
                          />
                        </Button>
                      </div>
                    ) : (
                      <div className={styles.logoPlaceholder}>
                        <div className={styles.logoCircle}>
                          <Building className="h-10 w-10 text-gray-400" />
                        </div>
                        <p className={`${styles.logoNote} dark:text-white`}>
                          Choose a company logo
                        </p>
                        <p
                          className={`${styles.logoSubNote} dark:text-white mb-5`}
                        >
                          PNG, JPG up to 5MB
                        </p>
                        {stepError?.clientLogo && (
                          <span className="small error color-danger">
                            {stepError.clientLogo}
                          </span>
                        )}
                        <Button
                          variant="outline"
                          className={styles.logoUploadButton}
                          asChild
                        >
                          <label className="d-flex flex-center">
                            <FileUploadOutlinedIcon
                              className={styles.iconSmaller}
                            />{" "}
                            Upload logo
                            <input
                              type="file"
                              accept="image/jpeg, image/png"
                              onChange={handleLogoUpload}
                              style={{ display: "none" }}
                            />
                          </label>
                        </Button>
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>

              <Card className="bg-white mt-30 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <CardHeader className="pb-12 pt-24 ph-24">
                  <CardTitle className="text-xl ">Your Pay Period</CardTitle>
                  <CardDescription
                    style={{ color: "#64748B", fontSize: "14px" }}
                  >
                    This setting applies to Time Sheets & Reports
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0 pb-24 ph-24">
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    className="mv-10"
                  >
                    Select the pay period start and end dates to define the
                    range of data shown in the report.
                  </p>
                  <div
                    className={
                      isMobile
                        ? "d-flex w-[350px] editEmp issueAlign"
                        : "d-flex w320 editEmp issueAlign"
                    }
                  >
                    <div className="d-flex flex-direction-column mv-7">
                      <span className="dark:text-white font-medium mb-5">
                        Pay Period Start Date
                      </span>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          //   label="Start Date"
                          className="customDate customDatePicker"
                          value={startDate}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                            if (
                              endDate &&
                              moment(newValue).isAfter(moment(endDate))
                            ) {
                              setEndDate(null);
                            }
                          }}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                        />
                      </LocalizationProvider>
                    </div>
                    <div
                      className={
                        isMobile
                          ? "d-flex flex-direction-column mv-7"
                          : "mh-20 d-flex flex-direction-column mv-7"
                      }
                    >
                      <span className="dark:text-white font-medium mb-5">
                        Pay Period End Date
                      </span>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          //   label="End Date"
                          className="customDate  customDatePicker"
                          value={endDate}
                          onChange={(newValue) => {
                            setEndDate(newValue);
                          }}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          minDate={
                            startDate
                              ? moment(startDate).add(1, "day")
                              : undefined
                          }
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="pay-period-display mt-10 border border-gray-300 dark:border-gray-600 rounded-lg p-12 inline-block bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-gray-100">
                    <strong>Pay Period:</strong>{" "}
                    {startDate && endDate ? (
                      <>
                        {moment(startDate).format("MMM DD, YYYY")} -{" "}
                        {moment(endDate).format("MMM DD, YYYY")}
                      </>
                    ) : (
                      <span style={{ color: "#888" }}>Not set</span>
                    )}
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-white mt-30 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <CardHeader className="pb-12 pt-24 ph-24">
                  <CardTitle className="text-xl">Industry Selection</CardTitle>
                  <CardDescription
                    style={{ color: "#64748B", fontSize: "14px" }}
                  >
                    Select the primary industry for client defaults and
                    templates
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0 pb-24 ph-24">
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    className="mv-10"
                  >
                    Select Industry
                  </p>
                  <div style={{ width: isMobile ? "350px" : "" }}>
                    <SingleSelectSearch
                      contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                      itemClass="dark:hover:bg-[#3c4351]"
                      value={industryName}
                      name={"industryName"}
                      onChange={(e) => handleIndustryNameChange(e)}
                      options={industryNameList}
                    />
                  </div>
                  {errors.industry && !industryName && (
                    <span className="d-flex small error color-danger">
                      Select Industry
                    </span>
                  )}

                  {industryName === "Add Industry" && (
                    <Card className="bg-white mt-30 ">
                      <CardHeader className="pb-12 pt-24 ph-24">
                        <CardTitle className="text-xl">Add Industry</CardTitle>
                      </CardHeader>
                      <CardContent className="pt-0 pb-24 ph-24">
                        <input
                          type="text"
                          placeholder="Industry Name"
                          value={newIndustry.name}
                          onChange={(e) =>
                            setNewIndustry((prev) => ({
                              ...prev,
                              name: e.target.value,
                            }))
                          }
                          className={styles.textInput}
                        />
                        <input
                          type="text"
                          placeholder="Industry Description"
                          value={newIndustry.description}
                          onChange={(e) =>
                            setNewIndustry((prev) => ({
                              ...prev,
                              description: e.target.value,
                            }))
                          }
                          className={`${styles.textInput} mt-15`}
                        />
                        <div className="button-group mt-10">
                          <Button
                            className={styles.btnPrimary}
                            onClick={handleAddIndustry}
                          >
                            Add Industry
                          </Button>
                          <Button
                            className={`${styles.cancel} ml-15`}
                            onClick={() => {
                              setNewIndustry({ name: "", description: "" });
                            }}
                          >
                            {" "}
                            Cancel
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  )}
                </CardContent>
              </Card>
            </div>
          )}
          {tab === "services" && <ClientSettingDetails props={props} />}
          <div className="mv-15">
            <Button
              variant="contained"
              style={{
                boxShadow: "none",
                backgroundColor: "#078037",
                color: "white",
              }}
              onClick={
                filterData?.length > 0 ? handleUpdateData : handleSaveData
              }
            >
              {filterData?.length > 0 ? "Update Changes" : "Save Changes"}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              style={{ marginLeft: 10, boxShadow: "none" }}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              variant="outlined"
              className="dark:text-white"
              style={{ marginLeft: 10, boxShadow: "none" }}
              onClick={() => navigate("/account/settings")}
            >
              Cancel
            </Button>
          </div>
          {filterData?.length > 0 && filterData?.changes?.length > 0 && (
            <ChangeHistory
              filterData={filterData}
              employeeData={employeeData}
            />
          )}
        </div>
      </Container>
      {confirmationDialog && (
        <CommonConfirmationDialog
          open={confirmationDialog}
          onClose={handleCloseConfirmDialog}
          onConfirm={handleConfirmDialog}
          title={"Industry Change Warning"}
          message={`You are electing to change the industry previously set for your company.
            This will not impact existing appointments, but you will not be able to
            create or edit new appointments with these shifts and tasks going
            forward. Do you wish to proceed?`}
          buttonTitle={"Proceed"}
        />
      )}
      {confirmationFinalDialog && (
        <CommonConfirmationDialog
          open={confirmationFinalDialog}
          onClose={handleFinalCloseConfirmDialog}
          onConfirm={handleFinalConfirmDialog}
          title={"Confirm Industry Change"}
          message={
            "Please confirm that you want to change your company industry setting in this app."
          }
          buttonTitle={"Yes"}
        />
      )}

      {open && (
        <CommonSuccessDialog
          open={open}
          onClose={handleColse}
          title={"Success"}
          message={"Your settings have been successfully saved."}
        />
      )}
      {updateOpen && (
        <CommonSuccessDialog
          open={updateOpen}
          onClose={handleUpdateClose}
          title={"Success"}
          message={"Your settings have been successfully update."}
        />
      )}
      {resetOpen && (
        <CommonConfirmationDialog
          open={resetOpen}
          onConfirm={handleResetConfirm}
          onClose={handleResetClose}
          title={"Setting Reset"}
          message={
            "Resetting the industry will impact future appointments linked to its tasks. Existing appointments won't be affected, but future ones may show missing or incorrect tasks. Are you sure you want to proceed?"
          }
          buttonTitle={"Yes"}
        />
      )}

      {showConfirmPopup && (
        <CommonConfirmationDialog
          open={showConfirmPopup}
          onConfirm={handleConfirm}
          onClose={() => {
            setShowConfirmPopup(false);
            setStartDate();
            setEndDate();
          }}
          title="Confirm Pay Period Change"
          message={`Are you sure you want to set this pay period from ${moment(
            startDate
          ).format("MMM DD, YYYY")} to ${moment(endDate).format(
            "MMM DD, YYYY"
          )}?`}
        />
      )}

      {resetSuccessOpen && (
        <CommonSuccessDialog
          open={resetSuccessOpen}
          onClose={handleResetSuccessClose}
          title={"Success"}
          message={"Your settings have been successfully reset."}
        />
      )}

      {companyEdit && (
            <CommonConfirmationDialog
              open={companyEdit}
              onConfirm={handleCompanyConfirm}
              onClose={handleEditDialogClose}
              title={"Company Name Change"}
              message={"Are you sure you want to change your company name?"}
              buttonTitle={"Yes"}
            />
          )}
    </>
  );
};

export default CompanyPageSetting;
